import Vue from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faBuilding,
  faTasks,
  faChartBar,
  faHeadset,
  faSignOutAlt,
  faTv,
  faLink,
  faCog,
  faUserTie,
  faUser
} from '@fortawesome/free-solid-svg-icons';

library.add(faBuilding);
library.add(faTasks);
library.add(faChartBar);
library.add(faHeadset);
library.add(faSignOutAlt);
library.add(faTv);
library.add(faLink);
library.add(faCog);
library.add(faUserTie);
library.add(faUser);

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
Vue.component('font-awesome-icon', FontAwesomeIcon);